import React from 'react';
import { toCurrency, toFormattedDate } from '@app/utilities';
import './PendingAuthorizations.css';
import ClearAuthorization from './ClearAuthorization';
import ReverseAuthorization from './ReverseAuthorization';
import { useGetSortedPendingAuthorizations } from '@app/sdk';
import { useAccountIdContext } from '../AccountIdContext';
import { Segment } from 'semantic-ui-react';
import { ColDef } from 'ag-grid-community';
import { Table } from '@app/shared';

export default function PendingAuthorizations() {
  const { accountId } = useAccountIdContext();

  const { data: pendingAuthorizations, isLoading } = useGetSortedPendingAuthorizations({ accountId });

  const columnDefs: ColDef[] = [
    { field: 'description', headerName: 'Description' },
    { field: 'transactionAmount', headerName: 'Amount', valueFormatter: (params) => toCurrency(params.value) },
    { field: 'remainingAmount', headerName: 'Remaining Float', valueFormatter: (params) => toCurrency(params.value) },
    {
      field: 'authorizationDate',
      headerName: 'Authorization Date',
      valueFormatter: (params) => toFormattedDate(params.value, 'yyyy-MM-dd HH:mm:ss'),
    },
    { field: 'authorizationId', headerName: 'Clear', cellRenderer: ClearAuthorization },
    { field: 'authorizationId', headerName: 'Reverse', cellRenderer: ReverseAuthorization },
  ];

  return (
    <Segment style={{ height: '400px' }}>
      <h2 className="ui header">
        Pending Authorizations {isLoading && <div className="ui active centered inline loader" />}
      </h2>
      <div style={{ height: '280px' }}>
        <Table items={pendingAuthorizations} columnDefs={columnDefs} />
      </div>
    </Segment>
  );
}
